/**
 * @generated SignedSource<<3569a19fadd937f8324f2cd7a1ed6c9e>>
 * @relayHash ddb1eba379ed1544bae77ce8070be56f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e8e74d715fec5fddbd3512bf92f9a13ef034b327df28b13fd1a6534cdc3677e0

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type CommentsSectionQuery$variables = {
  contentId: string;
  first?: AGG$Long | null;
  offset?: string | null;
};
export type CommentsSectionQuery$data = {
  readonly comments: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string | null;
      readonly node: {
        readonly ancestors: ReadonlyArray<{
          readonly id: string;
        } | null>;
        readonly author: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly permissionType?: SitePermissionType | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        };
        readonly body: {
          readonly value: string;
        };
        readonly contentStatus: string;
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        };
        readonly location: {
          readonly commentResolveProperties?: {
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineMarkerRef?: string | null;
          readonly inlineResolveProperties?: {
            readonly isDangling: boolean;
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineText?: string | null;
          readonly type: string;
        };
        readonly parentId: string | null;
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly reactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null>;
        } | null;
        readonly version: {
          readonly by: {
            readonly accountId?: string | null;
            readonly displayName: string | null;
            readonly type: string | null;
          } | null;
          readonly friendlyWhen: string | null;
          readonly number: number | null;
          readonly when: string | null;
        };
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
    readonly totalCount: number | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly createdBy: {
          readonly accountId?: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly space: {
        readonly homepageId: string | null;
        readonly id: string | null;
      } | null;
      readonly subType: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly displayName: string | null;
    readonly id: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type CommentsSectionQuery = {
  response: CommentsSectionQuery$data;
  variables: CommentsSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = {
  "kind": "Variable",
  "name": "pageId",
  "variableName": "contentId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "offset"
  },
  {
    "kind": "Literal",
    "name": "confluenceCommentFilter",
    "value": {
      "commentState": "UNRESOLVED",
      "commentType": "FOOTER"
    }
  },
  {
    "kind": "Literal",
    "name": "depth",
    "value": "ALL"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "FOOTER"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v6 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v8/*: any*/)
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v12 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionType"
    }
  ],
  "type": "KnownUser"
},
v15 = {
  "kind": "ScalarField",
  "name": "value"
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v18 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v19 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v16/*: any*/)
},
v20 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v21 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v23 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v24 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v25 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "kind": "ScalarField",
      "name": "inlineText"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isDangling"
        },
        (v22/*: any*/),
        (v23/*: any*/),
        (v24/*: any*/),
        (v25/*: any*/)
      ]
    }
  ],
  "type": "InlineComment"
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "commentResolveProperties",
      "plural": false,
      "selections": [
        (v22/*: any*/),
        (v23/*: any*/),
        (v24/*: any*/),
        (v25/*: any*/)
      ]
    }
  ],
  "type": "FooterComment"
},
v28 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v29 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v31 = {
  "kind": "ScalarField",
  "name": "number"
},
v32 = {
  "kind": "ScalarField",
  "name": "when"
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/)
  ],
  "type": "KnownUser"
},
v34 = {
  "args": [
    {
      "kind": "Literal",
      "name": "childType",
      "value": "comment"
    },
    {
      "kind": "Literal",
      "name": "contentType",
      "value": "page"
    },
    (v3/*: any*/)
  ],
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "reactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        }
      ]
    }
  ]
},
v35 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v36 = {
  "kind": "ScalarField",
  "name": "subType"
},
v37 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v38 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "homepageId"
    }
  ]
},
v39 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "concreteType": "AtlassianUserPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isPrimary"
        },
        (v15/*: any*/)
      ]
    },
    (v8/*: any*/)
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v40 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CommentsSectionQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "CommentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/)
                    ]
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ]
                  },
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v33/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v34/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v35/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v36/*: any*/),
              (v8/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v39/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommentsSectionQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "CommentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/)
                    ]
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      (v10/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ]
                  },
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v33/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v34/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v35/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v36/*: any*/),
              (v8/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      (v33/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v39/*: any*/)
    ]
  },
  "params": {
    "cacheID": "ddb1eba379ed1544bae77ce8070be56f",
    "id": "e8e74d715fec5fddbd3512bf92f9a13ef034b327df28b13fd1a6534cdc3677e0",
    "metadata": {},
    "name": "CommentsSectionQuery",
    "operationKind": "query",
    "text": "query CommentsSectionQuery($offset:String,$first:Long,$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId,type:FOOTER,depth:ALL,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER},first:$first,after:$offset){totalCount,pageInfo{hasNextPage,endCursor},edges{cursor,node{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}},content(id:$contentId){nodes{subType,id,operations{operation,targetType},space{id,homepageId},type,history{createdBy{__typename,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){displayName,photos{isPrimary,value},id}}"
  }
};
})();

(node as any).hash = "2dc784a3ffdaa1784c202cee08d95c7c";

export default node;
